import { Box, Button, Typography } from "@mui/material";
import React, { memo } from "react";
import { motion } from 'framer-motion';
import { When } from "react-if";

import { MotionContainer, varBounceIn } from "../animate";
interface Props {
    title: string,
    emoji?: string,
    description: string,
    buttonText: string | null,
    onClick(): void,
};

const NoData: React.FC<Props> = ({
    title,
    description,
    emoji,
    buttonText,
    onClick,
}) => {
    return (
        <MotionContainer open>
            <Box alignSelf={'center'} sx={{ 
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                // maxWidth: 600, 
                margin: 'auto', 
                textAlign: 'center', 
                mt: '2%', 
                mb: '2%',
            }}>

                <motion.div variants={varBounceIn}>
                    <Typography fontWeight={500} mt={1} variant="h6" paragraph>
                        {title}
                    </Typography>
                </motion.div>
                <Typography mb={2} sx={{ color: 'text.secondary' }}>
                    {description}
                </Typography>

                <When condition={buttonText && buttonText?.length > 0}>
                    <Button fullWidth={false} onClick={onClick} sx={{ mt: 1, mb: 2, width: 200, alignSelf: 'center' }} size="small" variant="contained">
                        {buttonText}
                    </Button>
                </When>
            </Box>
        </MotionContainer>
    )
}

export default memo(NoData);